import React from "react";
import TabFiles from "../../Files/TabFiles";

interface FilesTabProps {
  entityId: number;
}

const FilesTab: React.FC<FilesTabProps> = ({ entityId }) => {
  if (!entityId) return null;

  return (
    <TabFiles
      context="entity"
      entityId={entityId}
    />
  );
};

export default FilesTab;
